import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

/**
 * Prompt shown when a customer rejects a work item during CUSTOMER_REVIEW.
 * Closes with `{ reason: string }` (reason may be empty — it's optional).
 */
@Component({
  selector: 'app-reject-work-item-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './reject-work-item-modal.component.html',
  styleUrls: ['./reject-work-item-modal.component.scss']
})
export class RejectWorkItemModalComponent {
  @Input() modalRef: NgbModalRef | undefined;
  @Input() workItemTitle: string = '';

  reason: string = '';

  onReject(): void {
    if (this.modalRef) {
      this.modalRef.close({ reason: this.reason.trim() });
    }
  }

  onCancel(): void {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }
}
